import { useState } from "react";
import * as LucideIcons from "lucide-react";
import { type LucideIcon } from "lucide-react";
import { cn } from "../client/utils";

const ICON_LIST = [
  "LayoutDashboard", "BarChart3", "TrendingUp", "Target", "Zap",
  "Star", "Bookmark", "FileText", "Brain", "Wallet", "DollarSign",
  "Building2", "Timer", "Calendar", "BookOpen", "Activity",
  "PieChart", "Layers", "Gauge", "Flame", "Compass",
  "FolderOpen", "Hash", "Bell", "Shield", "Rocket",
  "Globe", "Award", "Briefcase", "LineChart",
] as const;

interface IconPickerPopoverProps {
  currentIcon: string;
  onSelect: (icon: string) => void;
  onClose: () => void;
}

export default function IconPickerPopover({ currentIcon, onSelect, onClose }: IconPickerPopoverProps) {
  const [query, setQuery] = useState("");
  const filtered = ICON_LIST.filter((k) => k.toLowerCase().includes(query.toLowerCase()));

  return (
    <div className="absolute left-0 top-full mt-1 z-50 bg-background border rounded-lg shadow-lg p-2 w-52">
      <input
        autoFocus
        value={query}
        onChange={(e) => setQuery(e.target.value)}
        placeholder="Filtrer..."
        className="w-full mb-2 px-2 py-1 text-xs border rounded outline-none bg-background"
        onKeyDown={(e) => e.key === "Escape" && onClose()}
      />
      <div className="grid grid-cols-6 gap-1 max-h-32 overflow-y-auto">
        {filtered.map((iconKey) => {
          const Ic = (LucideIcons as any)[iconKey] as LucideIcon;
          if (!Ic) return null;
          return (
            <button
              key={iconKey}
              type="button"
              title={iconKey}
              onClick={() => { onSelect(iconKey); onClose(); }}
              className={cn(
                "p-1.5 rounded flex items-center justify-center hover:bg-muted transition-colors",
                currentIcon === iconKey && "bg-primary/20 ring-1 ring-primary"
              )}
            >
              <Ic className="h-3.5 w-3.5" />
            </button>
          );
        })}
      </div>
    </div>
  );
}
